import React from 'react';

const InputField = ({textAlign = "left", customClasses = "", ...props}) => {

  const { meta: { touched, error } } = props;
  const className = `form-group ${touched && error ? "has-danger" : ""}`;

  return (
    <div className={className}>
      {(() => {
        if (!props.hideLabel) {
          return <label>{props.label}</label>;
        }
      })()}
      {props.type === "textarea" ? (
        <textarea
          className={`form-control form-control-custom ${customClasses}`}
          id={props.id}
          placeholder={props.placeholder}
          disabled={props.disabled}
          maxLength={props.maxLength}
          rows={props.rows}
          {...props.input}
        />
      ) : (
        <input
          className={`form-control text-${textAlign} form-control-custom ${customClasses}`}
          id={props.id}
          type={props.type}
          placeholder={props.placeholder}
          disabled={props.disabled}
          {...props.input}
        />
      )}

      <div>{error ? error : ""}</div>
    </div>
  );
};

export default InputField;


// WEBPACK FOOTER //
// ./src/components/forms/InputField/InputField.jsx